import React from "react";

import Feedback from "views/Admin/Feedback.js";
import Account from "views/Admin/Account.js";

import SimpleEntry from "views/Auth/SimpleEntry.js";
import SignUp from "views/Customer/SignUp.js";
import Contact from "components/Contact/Contact";
import About from "components/About/About";
import Pricing from "views/Pricing/Pricing.js";
import Journals from "views/Journal/Journals";

import FeedbackIcon from "@mui/icons-material/Feedback";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';

const PrivacyPolicy = React.lazy(() => import("views/Legal/PrivacyPolicy"));
const CookiePolicy = React.lazy(() => import("views/Legal/CookiePolicy"));
const Project = React.lazy(() => import("views/Admin/Project"));

const JournalEntry1 = React.lazy(() => import("views/Journal/JournalEntry1"));
const JournalEntry2 = React.lazy(() => import("views/Journal/JournalEntry2"));
const JournalEntry3 = React.lazy(() => import("views/Journal/JournalEntry3"));

import { getAuth, onAuthStateChanged } from "firebase/auth";

const auth = getAuth();

var dashRoutes = [
  {
    path: "/project",
    name: "",
    component: Project,
    layout: "/admin",
    project: true,
  },
  {
    path: "/admin/project",
    name: "Premium is now free!",
    component: "",
    layout: "",
    adminItem: true,
    icon: WorkspacePremiumIcon,
  },
  {
    path: "/account",
    name: "Account",
    component: Account,
    layout: "/admin",
    adminItem: true,
    icon: AccountCircleIcon,
  },
  {
    path: "/feedback",
    name: "Developer feedback",
    component: Feedback,
    layout: "/admin",
    adminItem: true,
    icon: FeedbackIcon,
  },
  {
    path: "/privacy-policy",
    name: "Privacy Policy",
    component: PrivacyPolicy,
    layout: "/legal",
  },
  {
    path: "/cookie-policy",
    name: "Cookie Policy",
    component: CookiePolicy,
    layout: "/legal",
  },
  {
    path: "/a-guide-to-stakeholder-mapping-tools",
    name: "A guide to stakeholder mapping tools",
    component: JournalEntry3,
    layout: "/journal",
    data: {
      imageSrc: require("assets/img/blogs/blog3/landing.jpg"),
    },
  },
  {
    path: "/how-to-treat-your-career-like-a-project",
    name: "How to treat your career like a project",
    component: JournalEntry1,
    layout: "/journal",
    data: {
      imageSrc: require("assets/img/blogs/blog1/landing-min.jpg"),
    },
  },
  {
    path: "/startups-and-their-need-for-stakeholder-analysis",
    name: "Startups and their need for Stakeholder Analysis",
    component: JournalEntry2,
    layout: "/journal",
    data: {
      imageSrc: require("assets/img/blogs/blog2/HandsLandingImage-min.jpeg"),
    },
  },
  {
    path: "/",
    name: "Journal",
    component: Journals,
    layout: "/journal",
  },
  {
    path: "/",
    name: "Entry",
    component: SimpleEntry,
    layout: "/auth",
  },
  {
    path: "/",
    name: "Pricing",
    component: Pricing,
    layout: "/plans",
  },
  {
    path: "/sign-up",
    name: "Pricing",
    component: SignUp,
    layout: "/customer",
  },
  {
    path: "/",
    name: "Contact",
    component: Contact,
    layout: "/contact-us",
  },
  {
    path: "/",
    name: "About",
    component: About,
    layout: "/about",
  },
];

onAuthStateChanged(auth, (user) => {
  if (user) {
    dashRoutes = dashRoutes.filter(route => route.name !== "Premium is now free!");
    } else {
  }
});

export { dashRoutes };
